import React from 'react';
import Loader from '../Loader';
import * as styles from './FullScreenLoader.styles';

const FullScreenLoader: React.FC = () => {
  return (
    <div style={styles.container}>
      <Loader />
    </div>
  );
};

export default FullScreenLoader;
